import BaseAPIService from '../base/base-api-service';
import WarrantyClaimModel from 'src/model/warrantyClaim.model';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

export interface IWarrantyClaimCanada {
  accountNumber: string;
  companyName: string;
  customerAddress: string;
  customerCity: string;
  customerName: string;
  customerPhone: string;
  customerPostalCode: string;
  claimDate: string; // yyyy-mm-dd
  dateCall: string; // yyyy-mm-dd
  dateFailed: string; // yyyy-mm-dd
  defect: string;
  email: string;
  invoiceNumber: number;
  manufacturer: string;
  model: string;
  partNumber: string;
  price: number;
  purchaseDate: string; // yyyy-mm-dd
  quantity: number;
  serialNumber: string;
}

class WarrantyClaimService extends BaseAPIService<WarrantyClaimModel> {
  private wpBaseURL: string = env.REACT_APP_BASE_WORDPRESS_URL;
  public endpoint: string = 'wp-json/acf/v3/warrantyClaimField?page=1&per_page=100';

  constructor() {
    super(WarrantyClaimModel);
  }

  public usBrandList() {
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'get',
        url: this.wpBaseURL + this.endpoint
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public createWarrantyClaim(partClaimData: any) {
    const partClaimEndpoint = `${this.baseURL}accountapp/v1/warranty/claims`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'post',
        url: partClaimEndpoint,
        data: partClaimData
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  public objToQueryString(obj: any) {
    console.log(obj);
    const keyValuePairs = [];
    for (let i = 0; i < Object.keys(obj).length; i += 1) {
      keyValuePairs.push(
        `${encodeURIComponent(Object.keys(obj)[i])}=${encodeURIComponent(
          Object.values(obj)[i].toString()
        )}`
      );
    }
    return keyValuePairs.join('&');
  }
  public checkClaimSubmitted(partClaimData: any) {
    return new Promise((resolve, reject) => {
      const iParams: any = {
        originalInvoiceNumber: partClaimData.part[0].invoiceNumber,
        partNumber: partClaimData.part[0].partNumber,
        prevClaimNumber: partClaimData.previousClaimNumber
      };

      const csAPIUrl = `${
        this.baseURL
      }warrantyapp/v1/part-claim/isClaimResubmitted?${this.objToQueryString(
        iParams
      )}`;
      this.doRequest({
        method: 'get',
        url: csAPIUrl
      })
        .then(response => {
          resolve(response);
        })
        .catch((error: any) => {
          // console.log(error);
          reject(error);
        });
    });
  }
  public newWarrantyClaim(partClaimData: any) {
    const partClaimEndpoint = `${this.baseURL}warrantyapp/v1/part-claim`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'post',
        url: partClaimEndpoint,
        data: partClaimData
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getClaimNumber() {
    const accountId = localStorage.getItem('activeAccount');
    console.log(accountId);
    return new Promise((resolve, reject) => {
      const claimNumberEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/number?claimType=defective&accountId=${accountId}`;
      this.doRequest({
        method: 'get',
        url: claimNumberEndpoint
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  // PART LIST

  public getPartnumber(
    datefilter: any,
    partnumber: any,
    isDamagedClaim?: boolean
  ) {
    return new Promise((resolve, reject) => {
      const regExp = /\(([^)]+)\)/;
      const part = regExp.exec(partnumber.trim())
        ? escape(partnumber.trim())
        : encodeURIComponent(partnumber.trim());

      const partNumberEndpoint = isDamagedClaim
        ? `${this.baseURL}warrantyapp/v1/part/partInvoices?dateFilter=${datefilter}&partNumber=${part}&isDamagedClaim=${isDamagedClaim}`
        : `${this.baseURL}warrantyapp/v1/part/partInvoices?dateFilter=${datefilter}&partNumber=${part}`;
      // const partNumberEndpoint = `${this.baseURL}warrantyapp/v1/part/partInvoices?dateFilter=${datefilter}&partNumber=${partnumber}`;

      this.doRequest({
        method: 'get',
        url: partNumberEndpoint
      })
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          console.log(error, 'waarra');
          reject(error);
        });
    });
  }
  // purchase date //

  public getpurchaseDate(partnumber: any, invoiceNumber: any) {
    return new Promise((resolve, reject) => {
      // const partNumberEndpoint = `${this.baseURL}warrantyapp/v1/part/partNumber/${partnumber}`;
      const purchaseDateEndpoint = `${this.baseURL}warrantyapp/v1/part/purchaseDate?invoiceNumber=${invoiceNumber}&partNumber=${partnumber}`;

      this.doRequest({
        method: 'get',
        url: purchaseDateEndpoint
      })
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          console.log(error, 'waarra');
          reject(error);
        });
    });
  }

  // get price details using invoicenumber //
  public getInvoicenumber(invoicenumber: any) {
    return new Promise((resolve, reject) => {
      const invoiceNumberEndpoint = `${this.baseURL}warrantyapp/v1/part/partNumber/${invoicenumber}`;
      this.doRequest({
        method: 'get',
        url: invoiceNumberEndpoint
      })
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          console.log(error, 'waarra');
          reject(error);
        });
    });
  }

  // get model number //

  public getModelnumber(modelnumber: any) {
    return new Promise((resolve, reject) => {
      const regExp = /\(([^)]+)\)/;
      const modelnum = regExp.exec(modelnumber)
        ? escape(modelnumber)
        : encodeURIComponent(modelnumber);
      const modelNumberEndpoint = `${this.baseURL}navapp/v1/search/modelProduct?q=${modelnum}`;

      // const modelNumberEndpoint = `${this.baseURL}navapp/v1/search/modelProduct?q=${modelnumber}`;
      this.doRequest({
        method: 'get',
        url: modelNumberEndpoint
      })
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          console.log(error, 'waarra');
          reject(error);
        });
    });
  }
  // get picture of part //

  public getPicofpart(formData: any) {
    return new Promise((resolve, reject) => {
      const picofpartEndpoint = `${this.baseURL}warrantyapp/v1/upload/pictureUploads`;

      this.doRequest({
        method: 'POST',

        url: picofpartEndpoint,
        data: formData
      })
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  public deletePicofpart(formData: any) {
    return new Promise((resolve, reject) => {
      const deleteEndpoint = `${this.baseURL}warrantyapp/v1/upload/deletePicture`;

      console.log(formData.claimNumber, 'apicheck');
      this.doRequest({
        method: 'POST',
        // headers: {
        //   'Content-Length': formData.length,

        //   'Content-Type': 'multipart/form-data'
        // },
        url: deleteEndpoint,
        data: formData
      })
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public createWarrantyClaimCanada(partClaimData: IWarrantyClaimCanada) {
    const partClaimEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/canada`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'post',
        url: partClaimEndpoint,
        data: partClaimData
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getBrands() {
    const partClaimBrandEndpoint = `${this.baseURL}navapp/v1/brands`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'get',
        url: partClaimBrandEndpoint
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const WarrantyClaimServiceInstance = new WarrantyClaimService();
Object.freeze(WarrantyClaimServiceInstance);

export default WarrantyClaimServiceInstance;
